import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import SubscribePage from "./pages/SubscribePage";
import ManageCoupons from "./pages/ManageCoupons";
import LandingPage from "./pages/LandingPage";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ShopDetails from "./pages/ShopDetails";
import BookingPage from "./pages/BookingPage";
import MyBookings from "./pages/MyBookings";
import BarberDashboard from "./pages/BarberDashboard";
import CreateShop from "./pages/CreateShop";
import EditShop from "./pages/EditShop";
import Navbar from "./components/Navbar";
import NotFound from "./pages/NotFound";
import HomeBookingPage from "./pages/HomeBookingPage";


const ProtectedRoute = ({ children, role }) => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" />;
  if (role && user.role !== role) return <Navigate to="/shops" />;
  return children;
};

function AppRoutes() {
  const location = useLocation();

  return (
    <>
      {!["/", "/login", "/register"].includes(location.pathname) && <Navbar />}
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/shops" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/shops/:id" element={<ShopDetails />} />

        {/* Customer Routes */}
        <Route path="/book/:shopId" element={
          <ProtectedRoute role="customer"><BookingPage /></ProtectedRoute>
        } />
        <Route path="/home-booking/:shopId" element={
          <ProtectedRoute role="customer"><HomeBookingPage /></ProtectedRoute>
        } />
        <Route path="/my-bookings" element={
          <ProtectedRoute role="customer"><MyBookings /></ProtectedRoute>
        } />

        {/* Barber Routes */}
        <Route path="/dashboard" element={
          <ProtectedRoute role="barber"><BarberDashboard /></ProtectedRoute>
        } />
        <Route path="/create-shop" element={
          <ProtectedRoute role="barber"><CreateShop /></ProtectedRoute>
        } />
        <Route path="/edit-shop/:shopId" element={
          <ProtectedRoute role="barber"><EditShop /></ProtectedRoute>
        } />
        <Route path="/subscribe/:shopId" element={
          <ProtectedRoute role="barber"><SubscribePage /></ProtectedRoute>
        } />
        <Route path="/coupons" element={
          <ProtectedRoute role="barber"><ManageCoupons /></ProtectedRoute>
        } />
        {/* 404 — must be last! */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}